/**
 * Determines if the current page path is a blog page (e.g., /blog/something)
 * will return false for the search page (/blog/search) and category pages (/blog/category/something).
 *
 * @param pagePath - The current page path, or null if not available
 * @returns true if the current page path is a blog page, false otherwise
 */
export const isOnBlogPage = (pagePath: string | null) => {
  const blogRegex = /^\/blog\/(?!category\/)(?!search$).+/;

  const isOnBlogPage = pagePath && blogRegex.test(pagePath);

  return !!isOnBlogPage;
};
